const IconSearch = ({
  fill,
  width,
  height,
}: {
  fill: string
  width: string
  height: string
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.75 2.5C5.29822 2.5 2.5 5.29822 2.5 8.75C2.5 12.2018 5.29822 15 8.75 15C10.231 15 11.5918 14.4849 12.6628 13.624C12.6744 13.6377 12.6868 13.651 12.6997 13.6639L16.3361 17.3003C16.6023 17.5666 17.034 17.5666 17.3003 17.3003C17.5666 17.034 17.5666 16.6023 17.3003 16.3361L13.6639 12.6997C13.651 12.6868 13.6377 12.6744 13.624 12.6628C14.4849 11.5918 15 10.231 15 8.75C15 5.29822 12.2018 2.5 8.75 2.5ZM3.75 8.75C3.75 5.98858 5.98858 3.75 8.75 3.75C11.5114 3.75 13.75 5.98858 13.75 8.75C13.75 11.5114 11.5114 13.75 8.75 13.75C5.98858 13.75 3.75 11.5114 3.75 8.75Z'
        fill={fill}
      />
    </svg>
  )
}

export default IconSearch
